// src/components/docs/Callout.tsx
import React from "react";
import clsx from "clsx";

const styles = {
  info: "border-blue-300 bg-blue-50 text-blue-900",
  warning: "border-yellow-400 bg-yellow-50 text-yellow-900",
  tip: "border-green-400 bg-green-50 text-green-900",
};

export default function Callout({
  type = "info",
  title,
  children,
}: {
  type?: "info" | "warning" | "tip";
  title?: string;
  children: React.ReactNode;
}) {
  return (
    <div
      className={clsx(
        "my-6 rounded-xl border-l-4 p-4",
        styles[type]
      )}
    >
      {title && (
        <div className="mb-2 font-semibold">{title}</div>
      )}

      {/* 👇 فقط div */}
      <div className="space-y-2 text-sm">{children}</div>
    </div>
  );
}
